import { AbstractModel } from '../base';
import { IOrder, IOrderData } from './order.types';

export class Order extends AbstractModel implements IOrder {
  series: string;
  customer_num: string;

  // TODO: 2024-03-26 - LH - IN FUTURE THIS SHOULD NOT BE NULLABLE
  delcode: string | null = null;
  cotp: string | null = null;
  currency: string | null = null;
  refb: string | null = null;
  eono: string | null = null;

  created_at?: Date;
  updated_at?: Date;
  constructor(data: IOrderData) {
    super();

    // Validate data
    this.validate(data, ['series', 'customer_num']);

    this.series = data.series!;
    this.customer_num = data.customer_num!;

    if (data.delcode) {
      this.delcode = data.delcode;
    }
    if (data.cotp) {
      this.cotp = data.cotp;
    }
    if (data.currency) {
      this.currency = data.currency;
    }
    if (data.refb) {
      this.refb = data.refb;
    }
    if (data.eono) {
      this.eono = data.eono;
    }

    if (data.created_at) {
      this.created_at =
        typeof data.created_at === 'string'
          ? new Date(data.created_at)
          : data.created_at;
    }

    if (data.updated_at) {
      this.updated_at =
        typeof data.updated_at === 'string'
          ? new Date(data.updated_at)
          : data.updated_at;
    }
  }
}
